import { Link } from "react-router-dom";
import { ArrowRight, CircleCheck, Facebook, Instagram, Youtube } from "lucide-react";
import { APP_ROUTES } from "../../routes/AppRoutes";
import heroCutout from "../../assets/images/whatwedo/influencerMarketing/influencer.png";

// Same layout as the Events & Experiences hero (.ee-hero-* in eventsExperiences.css).
const POINTS = [
  "Creators picked for audience fit, not follower count",
  "Contracts, approvals and payments handled for you",
  "Results reported per creator",
];

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61571039155522" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/hkiofficial" },
  { icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@Hki_music" },
];

const InfluencerHero = () => (
  <section className="ee-hero">
    {/* Themed backdrop, colour blob, outlined word and creator cutout. */}
    <div className="ee-hero-visual" aria-hidden="true">
      <div className="ee-hero-bg" />
      <div className="ee-hero-blob" />
      <span className="ee-hero-word">Creators</span>
      <img className="ee-hero-cutout" src={heroCutout} alt="" />
    </div>

    <div className="ee-hero-card" data-aos="fade-right" data-aos-once="true">
      <span className="ee-hero-card-kicker">Influencer Marketing</span>
      <h1 className="ee-hero-card-title">
        Creators who influence. <span>Campaigns that perform.</span>
      </h1>
      <p className="ee-hero-card-lead">The right creators, every step managed, real results reported.</p>
      <p className="ee-hero-card-desc">
        Across Instagram, YouTube and regional platforms. Planning an event or launch? Hand us the whole campaign.
      </p>
      <ul className="ee-checks">
        {POINTS.map((point) => (
          <li key={point}>
            <CircleCheck size={16} /> {point}
          </li>
        ))}
      </ul>
      <Link to={APP_ROUTES.CONTACT_US} className="ee-btn">
        Start a Campaign <ArrowRight size={16} />
      </Link>
    </div>

    <div className="ee-hero-bar">
      <div className="ee-hero-socials">
        {SOCIALS.map(({ icon: Icon, label, href }) => (
          <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}>
            <Icon size={16} />
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default InfluencerHero;
